import { combineReducers } from '@reduxjs/toolkit'

import { aiSlice } from '@/features/aiAssistant'
import { chainlitApiSlice } from '@/features/aiAssistant/redux'
import { mddApiSliceGenerated } from '@/rtkApi'
import { mddApiSliceGeneratedV2 } from '@/rtkApi/mddApiSliceGeneratedV2'
import {
	diagramApiSlice,
	historyApiSlice,
	templateApiSlice,
} from '@/rtkQueries'

import { diagram, miscSlice } from '../slices'
import acronyms from './acronyms'
import actionsTimestamps from './actionsTimestamps'
import apiCollection from './apiCollection'
import apiError from './apiError'
import apiNode from './apiNode'
import auth from './auth'
import businessDomain from './businessDomain'
import folder from './folder'
import formHighlights from './formHighlights'
import mapping from './mapping'
import node from './node'
import queue from './queue'
import readMapping from './readMapping'
import settings from './settings'
import stereotype from './stereotype'
import system from './system'
import tab from './tab'
import table from './table'
import technology from './technology'
import user from './user'
import view from './view'
import workflow from './workflow'
import writeMapping from './writeMapping'

const apiReducers = {
	[diagramApiSlice.reducerPath]: diagramApiSlice.reducer,
	[historyApiSlice.reducerPath]: historyApiSlice.reducer,
	[templateApiSlice.reducerPath]: templateApiSlice.reducer,
	[chainlitApiSlice.reducerPath]: chainlitApiSlice.reducer,
	[mddApiSliceGenerated.reducerPath]: mddApiSliceGenerated.reducer,
	[mddApiSliceGeneratedV2.reducerPath]: mddApiSliceGeneratedV2.reducer,
}
const reducers = {
	acronyms,
	actionsTimestamps,
	apiCollection,
	apiError,
	apiNode,
	auth,
	businessDomain,
	diagram,
	folder,
	formHighlights,
	mapping,
	miscSlice,
	node,
	queue,
	readMapping,
	settings,
	stereotype,
	system,
	tab,
	table,
	technology,
	user,
	view,
	workflow,
	writeMapping,
	aiSlice,
	...apiReducers,
}

export const rootReducer = combineReducers(reducers)

export * from '../slices'
